// extracted by mini-css-extract-plugin
module.exports = {"budget":"NavigationPanel_budget__csa5J","relatedLinks":"NavigationPanel_relatedLinks__Hg8dx","theme":"NavigationPanel_theme__3k48W"};